import React from 'react';
import { FlatList, StyleSheet } from 'react-native';
import { Heading, HeadingTypes } from '../../components';
import Theme from '../../theme';

import PartnerCard from './PartnerCard';

const PartnerList = ({
  t, partners, handelInvite, isLoading, hasSearched, selectedPartner,
}) => (
  <FlatList
    data={partners}
    ListHeaderComponent={<ListHeader t={t} isLoading={isLoading} partners={partners} />}
    ListEmptyComponent={<EmptyPartner t={t} partners={partners} isLoading={isLoading} hasSearched={hasSearched} />}
    keyExtractor={item => item.uid}
    renderItem={({ item }) => !isLoading && (
      <PartnerCard
        t={t}
        partner={item}
        isLoadingApi={isLoading}
        handelInvite={handelInvite}
        selectedPartner={selectedPartner}
      />
    )}
  />
);

const ListHeader = ({ t, partners, isLoading }) =>
  (partners.length > 0 && !isLoading &&
    <Heading
      title={t('found')}
      style={styles.header}
      headerType={HeadingTypes.HEADING_TWO}
    />
  );

const EmptyPartner = ({ t, isLoading, hasSearched }) =>
  (!isLoading && hasSearched
    &&
      <Heading
        title={t('noPartnersFound')}
        style={styles.header}
        headerType={HeadingTypes.HEADING_TWO}
      />
  );

const styles = StyleSheet.create({
  header: {
    fontSize: 20,
   
    fontFamily:Theme.CustomBold,
    paddingVertical: 8,
    color: Theme.CHARCOAL,
  },
});

export default PartnerList;
